// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Badge-module-badge-12RIY{color:#373a36;font-size:8px;font-weight:var(--weight-light);letter-spacing:.09px;line-height:16px;border:1px solid #373a36;border-radius:15px;padding-block:4px;padding-block:var(--des-dimension-gap-and-padding-general-near-default, 4px);padding-inline:8px;padding-inline:var(--des-dimension-gap-and-padding-general-near-medium, 8px);width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;max-width:100%}.Badge-module-badge-12RIY span{font-size:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": "Badge-module-badge-12RIY"
};
export default ___CSS_LOADER_EXPORT___;
